/* eslint-disable import/prefer-default-export */
import omit from 'lodash/omit'

import {
    StandardBaseLeaseFilterRequestResponse,
} from 'app/requests/RateCard/RateCard.types'
import {
    BaseLeaseEditable,
} from './BaseLease.types'

export const prepareBaseLeaseToBulkEdit = (
    items: StandardBaseLeaseFilterRequestResponse[] = [],
): BaseLeaseEditable[] => {
    return items.map((i) => {
        return omit(i, [
            'productType',
            'currency',
            'baseLeaseCategory',
        ])
    })
}
